// Translations
import landing from '../views/landing/translations/ua'

// Translation: Two-factor authentication (Ukrainian)
export default Object.freeze({
	name: '',
	views: { landing }
})
